export default __webpack_public_path__ + "static/media/pin-monitor-offline.3b4a851c.png";